import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";
import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import SignIn from "@/pages/SignIn.vue";
import CustomTableHeader from "@/components/Tables/shortcut/CustomTableHeader";
// Plugins
import GlobalDirectives from "./globalDirectives";
import Notifications from "vue-notification";
// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";
import { ClientTable, ServerTable } from "vue-tables-2-premium";
import * as VueGoogleMaps from "vue2-google-maps";

import "jsondiffpatch/dist/formatters-styles/annotated.css";
import "jsondiffpatch/dist/formatters-styles/html.css";
import "vue-datetime/dist/vue-datetime.css";

// import Chartist from "chartist";

import Axios from "axios";
import Nodes from "./pages/Nodes";
import Shortcuts from "./pages/Shortcuts";
import NewNode from "./pages/NewNode";
import EditNode from "./pages/EditNode";
import NewShortcut from "./pages/NewShortcut";
import EditShortcut from "./pages/EditShortcut";
import ListShortcuts from "./pages/ListShortcuts";
import VueClipboard from "vue-clipboard2";
import Vuelidate from "vuelidate";
import ServerBundles from "./pages/ServerBundles";
import Store from "./pages/Store";
import AppPage from "./pages/AppPage";
import EditProduct from "./pages/EditProduct";
import NewProduct from "./pages/NewProduct";
import Promocodes from "./pages/Promocodes";
import PromocodeGroups from "./pages/PromocodeGroups";
import DashboardMap from "@/pages/DashboardMap";
import ShortcutReviewMode from "@/pages/ShortcutReviewMode";
import APITable from "./pages/APITable";
import Users from "./pages/Users";
import UserDetails from "./pages/UserDetails";
import SearchAppleOrderId from "./pages/SearchAppleOrderId";
import AdminManagement from "./pages/AdminManagement";
import EditShortcutV2 from "./pages/shortcutsV2/EditShortcutV2";
import EditShortcutGroupV2 from "./pages/shortcutsV2/EditShortcutGroupV2";
import ShortcutsTableV2 from "./pages/shortcutsV2/ShortcutsTableV2";
import ShortcutGroupsTableV2 from "./pages/shortcutsV2/ShortcutGroupsTableV2";
import EnhancersTableV2 from "./pages/shortcutsV2/EnhancersTableV2";
import EditEnhancerV2 from "./pages/shortcutsV2/EditEnhancerV2";
import AccountCodes from "./pages/AccountCodes.vue";

Axios.defaults.baseURL = process.env.VUE_APP_BACKEND_API;

Axios.interceptors.request.use(
    (config) => {
        // if (process.env.VUE_APP_MODE === "production") {
        //     config.headers['Access-Control-Allow-Origin'] = '*';
        // }

        let token = localStorage.getItem("jwt");

        if (token) {
            config.headers["Authorization"] = token;
        }

        config.headers["App-Identity"] = "admin.assguard.world";

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

Axios.interceptors.response.use(
    response => response,
    (error) => {
        const originalRequest = error.config;

        if (error.response.status === 401) {
            if (originalRequest.url !== "/v1/admin/refresh") {
                return Axios.post("/v1/admin/refresh", {
                    refresh_token: localStorage.getItem("refreshToken")
                }).then(
                    (res) => {
                        localStorage.setItem("jwt", res.data["access_token"]);
                        localStorage.setItem("refreshToken", res.data["refresh_token"]);
                        return Axios(originalRequest);
                    },
                    (err) => {
                        localStorage.removeItem("jwt");
                        localStorage.removeItem("refreshToken");
                        router.push("sign-in");

                        throw err;
                    }
                );
            } else {
                localStorage.removeItem("jwt");
                localStorage.removeItem("refreshToken");
                router.push("sign-in");
            }
        }
        return Promise.reject(error);
    }
);

Vue.prototype.$http = Axios;

// TODO: better solution
export let http = Vue.prototype.$http;

Vue.config.productionTip = false;

// configure router
let router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/",
            redirect: "/dashboard"
        },
        {
            path: "*",
            redirect: "/"
        },
        {
            path: "/sign-in",
            name: "sign-in",
            component: SignIn,
            meta: {
                guest: true
            }
        },
        {
            path: "/dashboard",
            component: DashboardLayout,
            meta: {
                requiresAuth: true
            },
            redirectTo: "dashboard",
            children: [
                {
                    path: "/",
                    name: "dashboard",
                    component: DashboardMap,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "/nodes",
                    name: "nodes",
                    component: Nodes,
                    meta: {
                        requiresAuth: true,
                        title: "Nodes",
                    },
                },
                {
                    path: "/node/new",
                    name: "node-new",
                    component: NewNode,
                    meta: {
                        requiresAuth: true,
                        title: "New Node",
                    },
                },
                {
                    path: "/node/edit/:id",
                    name: "node-edit",
                    component: EditNode,
                    meta: {
                        requiresAuth: true,
                        title: "Update Node",
                    },
                },
                {
                    path: "/shortcuts",
                    name: "shortcuts",
                    component: Shortcuts,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcuts",
                    },
                },
                {
                    path: "/shortcut/new",
                    name: "shortcuts-new",
                    component: NewShortcut,
                    meta: {
                        requiresAuth: true,
                        title: "New Shortcut",
                    },
                },
                {
                    path: "/shortcut-search",
                    name: "shortcuts-search",
                    component: ListShortcuts,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcut Search",
                    },
                },
                {
                    path: "/shortcut/edit/:id",
                    name: "shortcut-edit",
                    component: EditShortcut,
                    meta: {
                        requiresAuth: true,
                        title: "Edit Shortcut",
                    },
                },
                {
                    path: "/shortcut/variant/:id",
                    name: "create-shortcut-variant",
                    component: EditShortcut,
                    meta: {
                        requiresAuth: true,
                        title: "Create Shortcut Variant",
                    },
                },
                {
                    path: "/shortcuts/review-mode",
                    name: "shortcuts-review-mode",
                    component: ShortcutReviewMode,
                    meta: {
                        requiresAuth: true,
                        title: "App Review Mode",
                    },
                },
                {
                    path: "/shortcuts/v2",
                    name: "shortcuts-v2",
                    component: ShortcutsTableV2,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcuts V2",
                    },
                },
                {
                    path: "/shortcuts/v2/create",
                    name: "shortcut-create-v2",
                    component: EditShortcutV2,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcut Create V2",
                    },
                },
                {
                    path: "/shortcuts/v2/edit/:id",
                    name: "shortcut-edit-v2",
                    component: EditShortcutV2,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcut Edit V2",
                    },
                },
                {
                    path: "/shortcuts/v2/groups",
                    name: "shortcuts-groups-v2",
                    component: ShortcutGroupsTableV2,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcut Groups V2",
                    },
                },
                {
                    path: "/shortcuts/v2/group/create",
                    name: "shortcut-group-create-v2",
                    component: EditShortcutGroupV2,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcut Group Create V2",
                    },
                },
                {
                    path: "/shortcuts/v2/group/edit/:id",
                    name: "shortcut-group-edit-v2",
                    component: EditShortcutGroupV2,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcut Group Edit V2",
                    },
                },
                {
                    path: "/shortcuts/v2/enhancers",
                    name: "shortcuts-enhancers-v2",
                    component: EnhancersTableV2,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcut Enhancers V2",
                    },
                },
                {
                    path: "/shortcuts/v2/enhancer/create",
                    name: "shortcut-enhancer-create-v2",
                    component: EditEnhancerV2,
                    meta: {
                        requiresAuth: true,
                        title: "Shortcut Enhancer Create V2",
                    },
                },
                {
                    path: "/server-bundles",
                    name: "server-bundles",
                    component: ServerBundles,
                    meta: {
                        requiresAuth: true,
                        title: "Server Bundles",
                    },
                },
                {
                    path: "/store",
                    name: "store",
                    component: Store,
                    meta: {
                        requiresAuth: true,
                        title: "Store",
                    },
                },
                {
                    path: "/app/:appid",
                    name: "app",
                    component: AppPage,
                    meta: {
                        requiresAuth: true,
                        title: "Apps",
                    }
                },
                {
                    path: "/app/:appid/product/new",
                    name: "New Product",
                    component: NewProduct,
                    meta: {
                        requiresAuth: true,
                        title: "New Product",
                    }
                },
                {
                    path: "/app/:appid/product/:id",
                    name: "Edit product",
                    component: EditProduct,
                    meta: {
                        requiresAuth: true,
                        title: "Edit Product",
                    },
                },
                {
                    path: "/app/:appid/product/:id/edit",
                    name: "Edit product v.2",
                    component: NewProduct,
                    meta: {
                        requiresAuth: true,
                        title: "Edit Product v.2",
                    },
                },
                {
                    path: "/app/:appid/product/:id/clone",
                    name: "Clone product",
                    component: NewProduct,
                    meta: {
                        requiresAuth: true,
                        title: "Clone Product",
                    },
                },
                {
                    path: "/promocodes",
                    name: "Promocodes",
                    component: Promocodes,
                    meta: {
                        requiresAuth: true,
                        title: "Promocodes"
                    }
                },
                {
                    path: "/promocodes/groups",
                    name: "Promocode groups",
                    component: PromocodeGroups,
                    meta: {
                        requiresAuth: true,
                        title: "Promocode groups"
                    }
                },
                {
                    path: "/promocodes/group/:group",
                    name: "Promocodes group",
                    component: Promocodes,
                    meta: {
                        requiresAuth: true,
                        title: "Promocodes group"
                    }
                },
                {
                    path: "/api-tokens",
                    name: "API Tokens",
                    component: APITable,
                    meta: {
                        requiresAuth: true,
                        title: "API Tokens"
                    }
                },
                {
                    path: "/users",
                    name: "Users",
                    component: Users,
                    meta: {
                        requiresAuth: true,
                        title: "Users"
                    }
                },
                {
                    path: "/user/:id",
                    name: "User Details",
                    component: UserDetails,
                    meta: {
                        requiresAuth: true,
                        title: "User Details"
                    }
                },
                {
                    path: "/users/apple-order-id",
                    name: "Apple Order ID Search",
                    component: SearchAppleOrderId,
                    meta: {
                        requiresAuth: true,
                        title: "Apple Order ID Search",
                    }
                },
                {
                    path: "/users/generate-account-codes",
                    name: "Account Codes",
                    component: AccountCodes,
                    meta: {
                        requiresAuth: true,
                        title: "Account Codes",
                    }
                },
                {
                    path: "/admin-management",
                    name: "Admin Management",
                    component: AdminManagement,
                    meta: {
                        requiresAuth: true,
                        title: "Admin Management"
                    }
                }
            ]
        },
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem("jwt") == null) {
            next({
                path: "/sign-in",
                params: {nextUrl: to.fullPath}
            });
        }

        next();

    } else if (to.matched.some(record => record.meta.guest)) {
        if (localStorage.getItem("jwt") == null) {
            next();
        } else {
            next({name: "dashboard"});
        }
    } else {
        next();
    }
});

router.afterEach((to) => {
    let title;
    to.matched.forEach((route) => {
        if (route.meta.title) {
            title = route.meta.title;
        }
    });

    document.title = title ? title + " - Admin Panel" : "Admin panel";
});

Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalDirectives);
Vue.use(Notifications);
Vue.use(require("vue-moment"));
Vue.use(VueClipboard);
Vue.use(Vuelidate);
Vue.use(ClientTable, {}, false, "bootstrap3", {
    tableHeading: CustomTableHeader
});
Vue.use(ServerTable, {}, false, "bootstrap3", {
    tableHeading: CustomTableHeader
});
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDOrY0VqP3-lXRQ4__pTKjin5f1xNIQJZo",
        libraries: "places",
    },
    installComponents: true
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    data: {
    },
    render: h => h(App),
    router
});
